export default __webpack_public_path__ + "static/media/male@3x.9c34b5f7.png";